import {
  Box,
  Grid,
  Button,
  Link,
  Switch,
  Select,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  GetUserCountries,
  GetGroupOrScenarioDetails,
  UpdateGroupOrScenarioActivation,
  ListUpdateGroupOrScenario,
  setState,
} from "./centralAdminSlice";
import { DataGrid, useGridApiRef } from "@mui/x-data-grid";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import Alert from "../../components/ui/Alert";
import SharedComponent from "./SharedComponent";
import CollapseSection from "../../components/ui/CollapseSection";
import moment from "moment";

export default function GroupScenatioActivity() {
  const apiRef = useGridApiRef();
  const dispatch = useDispatch();
  const [alert, setAlert] = useState({});
  const centralAdmin = useSelector((state) => state.centralAdmin);
  const {
    isLoading,
    countries,
    selectedCountry,
    selectedCountryID,
    getGroupScenarioData,
    clearGroupScenarioData,
    listUpdateGS,
  } = centralAdmin;

  const [searchText, setSearchText] = useState("");
  const [viewBy, setViewBy] = useState("");
  const [updatedIds, setUpdatedIds] = useState([]);
  const [visibleColumns, setVisibleColumns] = useState([]);
  const [filterData, setFilterData] = useState(getGroupScenarioData);

  const columns = [
    { field: "groupOrScenarioName", headerName: "Name", flex: 1 },
    {
      field: "validityStartDate",
      headerName: "Validity Start Date",
      flex: 1,
      valueFormatter: (params) =>moment(params.value).format('DD/MM/YYYY')
    },
    {
      field: "validityEndDate",
      headerName: "Valid End Date",
      flex: 1,
      valueFormatter: (params) => moment(params.value).format('DD/MM/YYYY')
    },
    {
      field: "activation",
      headerName: "Activity",
      flex: 1,
      renderCell: (params) => {
        return <Deactivate {...params} />;
      },
    },

    {
      field: "inactive",
      headerName: "Show / Hide",
      flex: 1,
      renderCell: (params) => {
        return <Inactive {...params} />;
      },
    },
    {
      field: "scenarioCriticality",
      headerName: "Criticality",
      flex: 1,
      renderCell: (params) => {
        return <Criticality {...params} />;
      },
    },
    {
      field: "stickToQuota",
      headerName: "Automate STQ Decision",
      flex: 1,
      renderCell: (params) => {
        return <StickToQuota {...params} />;
      },
    },
    {
      field: "unblockFullOrder",
      headerName: "UB Decision",
      flex: 1,
      renderCell: (params) => {
        return <UnblockFullOrder {...params} />;
      },
    },
    {
      field: "modifyStickToQuota",
      headerName: "MSQ Decision",
      flex: 1,
      renderCell: (params) => {
        return <ModifyStickToQuota {...params} />;
      },
    },
    {
      field: "copySubmitQuota",
      headerName: "	Copy & Submit Quota",
      flex: 1,
      renderCell: (params) => {
        return <CopySubmitQuota {...params} />;
      },
    },
  ];

  useEffect(() => {
    dispatch(setState("selectedCountry", ""));
    setViewBy("");
    dispatch(setState("clearGroupScenarioData", false));
  }, []);

  const Deactivate = (params) => {
    const handleDeactivate = () => {
      const obj = {
        GroupOrScenarioID: params.row.groupOrScenarioID,
        GroupOrScenarioType: viewBy,
        Inactive: params.row.inactive,
        Activity: "Deactivation",
        criticalityID: params.row.scenarioCriticality,
        PeriodType: params.row.periodType,
        sticktoQuota: params.row.stickToQuota,
      };

      let newObj = {
        countryID: selectedCountryID,
        viewBy: viewBy,
      };

      dispatch(GetGroupOrScenarioDetails(obj));

      dispatch(UpdateGroupOrScenarioActivation(obj)).then(() => {
        dispatch(GetGroupOrScenarioDetails(newObj));
      });
    };
    return (
      <Link onClick={handleDeactivate} sx={{ cursor: "pointer" }}>
        {params.row.activation !== "NA" ? params.row.activation : ""}
      </Link>
    );
  };

  const Inactive = (params) => {
    let inactiveValue = false;
    let isDisabledValue = false;

    params.row.inactive === 1
      ? (inactiveValue = true)
      : (inactiveValue = false);

    params.row.activation === "NA"
      ? (isDisabledValue = false)
      : (isDisabledValue = true);

    const [checked, setChecked] = React.useState(inactiveValue);
    const [isDisabled, setIsDisabled] = React.useState(isDisabledValue);
    const handleInactive = (e) => {
      setChecked(e.target.checked);
      apiRef.current.updateRows([
        {
          groupOrScenarioID: params.id,
          inactive: e.target.checked === true ? 1 : 0,
        },
      ]);
      if (!updatedIds.includes(params.id)) {
        // If not, add it to the state array
        //setUpdatedIds([...updatedIds, params.id]);
        setUpdatedIds((prevStateArray) => [...prevStateArray, params.id]);
      }
    };

    return (
      <Switch
        checked={checked}
        disabled={isDisabled}
        onChange={handleInactive}
        inputProps={{ "aria-label": "controlled" }}
      />
    );
  };

  const Criticality = (params) => {
    const [trustLevel, setTrustLevel] = useState(
      params.row.scenarioCriticality
    );

    const handleStatusChange = (e) => {
      setTrustLevel(e.target.value);
      apiRef.current.updateRows([
        { groupOrScenarioID: params.id, scenarioCriticality: e.target.value },
      ]);

      if (!updatedIds.includes(params.id)) {
        // If not, add it to the state array
        //setUpdatedIds([...updatedIds, params.id]);
        setUpdatedIds((prevStateArray) => [...prevStateArray, params.id]);
      }
    };
    return (
      <Select
        value={trustLevel}
        onChange={handleStatusChange}
        disabled= {params.row.inactive === 1 ? true : false}
        variant="outlined"
        size="small"
        fullWidth
      >
        <MenuItem value={1}>Low</MenuItem>
        <MenuItem value={2}>Medium</MenuItem>
        <MenuItem value={3}>High</MenuItem>
        <MenuItem value={4}>Severe</MenuItem>
        <MenuItem value={5}>Other</MenuItem>
      </Select>
    );
  };

  const StickToQuota = (params) => {
    //console.log(params.row.stickToQuota);
    const [status, setStatus] = useState(params.row.stickToQuota);

    const handleStatusChange = (e) => {
      setStatus(e.target.value);
      apiRef.current.updateRows([
        { groupOrScenarioID: params.id, stickToQuota: e.target.value },
      ]);

      // Perform additional actions here, such as updating the row data
      if (!updatedIds.includes(params.id)) {
        // If not, add it to the state array
        //setUpdatedIds([...updatedIds, params.id]);
        setUpdatedIds((prevStateArray) => [...prevStateArray, params.id]);
      }
    };

    return (
      <Select
        value={status}
        onChange={handleStatusChange}
        disabled= {params.row.inactive === 1 ? true : false}
        variant="outlined"
        size="small"
        fullWidth
      >
        <MenuItem value={1}>Enabled</MenuItem>
        <MenuItem value={0}>Disabled</MenuItem>
      </Select>
    );
  };

  const UnblockFullOrder = (params) => {
    //console.log(params.row.stickToQuota);
    const [status, setStatus] = useState(params.row.unblockFullOrder);

    const handleStatusChange = (e) => {
      setStatus(e.target.value);
      apiRef.current.updateRows([
        { groupOrScenarioID: params.id, unblockFullOrder: e.target.value },
      ]);

      // Perform additional actions here, such as updating the row data
      if (!updatedIds.includes(params.id)) {
        // If not, add it to the state array
        //setUpdatedIds([...updatedIds, params.id]);
        setUpdatedIds((prevStateArray) => [...prevStateArray, params.id]);
      }
    };

    return (
      <Select
        value={status}
        onChange={handleStatusChange}
        disabled= {params.row.inactive === 1 ? true : false}
        variant="outlined"
        size="small"
        fullWidth
      >
        <MenuItem value={1}>Enabled</MenuItem>
        <MenuItem value={0}>Disabled</MenuItem>
      </Select>
    );
  };

  const ModifyStickToQuota = (params) => {
    //console.log(params.row.stickToQuota);
    const [status, setStatus] = useState(params.row.modifyStickToQuota);

    const handleStatusChange = (e) => {
      setStatus(e.target.value);
      apiRef.current.updateRows([
        { groupOrScenarioID: params.id, modifyStickToQuota: e.target.value },
      ]);

      // Perform additional actions here, such as updating the row data
      if (!updatedIds.includes(params.id)) {
        // If not, add it to the state array
        //setUpdatedIds([...updatedIds, params.id]);
        setUpdatedIds((prevStateArray) => [...prevStateArray, params.id]);
      }
    };

    return (
      <Select
        value={status}
        onChange={handleStatusChange}
        disabled= {params.row.inactive === 1 ? true : false}
        variant="outlined"
        size="small"
        fullWidth
      >
        <MenuItem value={1}>Enabled</MenuItem>
        <MenuItem value={0}>Disabled</MenuItem>
      </Select>
    );
  };

  const CopySubmitQuota = (params) => {
    // console.log(params.row.stickToQuota);
    const [status, setStatus] = useState(params.row.copySubmitQuota);
    const handleStatusChange = (e) => {
      setStatus(e.target.value);

      apiRef.current.updateRows([
        { groupOrScenarioID: params.id, copySubmitQuota: e.target.value },
      ]);

      // Perform additional actions here, such as updating the row data
      if (!updatedIds.includes(params.id)) {
        // If not, add it to the state array
        //setUpdatedIds([...updatedIds, params.id]);
        setUpdatedIds((prevStateArray) => [...prevStateArray, params.id]);
      }
    };

    return (
      <Select
        value={status}
        onChange={handleStatusChange}
        disabled= {params.row.inactive === 1 ? true : false}
        variant="outlined"
        size="small"
        fullWidth
      >
        <MenuItem value={1}>Enabled</MenuItem>
        <MenuItem value={0}>Disabled</MenuItem>
      </Select>
    );
  };

  useEffect(() => {
    if (countries.length <= 0) {
      dispatch(GetUserCountries({ method: "Get" }));
    }
  }, [countries]);

  useEffect(() => {
    setFilterData(getGroupScenarioData);
  }, [getGroupScenarioData]);

  const handleSearchText = (e) => {
    const value = e.target.value;
    setSearchText(value);
  };

  useEffect(() => {
    let filteredRows = getGroupScenarioData;

    if (searchText !== "") {
      const searchLowercase = searchText.toLowerCase();
      filteredRows = filteredRows.filter((row) => {
        return row.groupOrScenarioName.toLowerCase().includes(searchLowercase);
      });
    }

    setFilterData(filteredRows);
  }, [searchText]);

  const handleDisplay = () => {
    setUpdatedIds([]);
    dispatch(setState("getGroupScenarioData",[]));
    setSearchText("");
    if (selectedCountry === null || selectedCountry === "") {
      displayWarningAlert("Country");
      return;
    }
    if (viewBy === null || viewBy === "") {
      displayWarningAlert("View By");
      return;
    }
    if (viewBy === 1 || viewBy === 2) {
      setVisibleColumns((prev) =>
        columns.filter(
          (col) =>
            col.field !== "scenarioCriticality" &&
            col.field !== "stickToQuota" &&
            col.field !== "copySubmitQuota" &&
            col.field !== "unblockFullOrder" &&
            col.field !== "modifyStickToQuota"
        )
      );
    } else {
      setVisibleColumns(columns);
    }
    //  /ProductGroup/GetSKUSwitchSearch?CountryID=150&ProductName=ABACAV/LAMIVUD&SKUType=0
    let obj = {
      countryID: selectedCountryID,
      viewBy: viewBy,
    };

    dispatch(setState("clearGroupScenarioData", true));
    dispatch(GetGroupOrScenarioDetails(obj));
  };

  const handleCountryChange = (e) => {
    const name = e.target.value;
    // console.log(countries.find((country) => country.countryName === name));
    const countryID = countries.find(
      (country) => country.countryName === name
    ).countryID;

    dispatch(setState("selectedCountry", name));
    dispatch(setState("selectedCountryID", countryID));
  };

  const handleSave = () => {
    const uniqueUpdatedIds = Array.from(new Set(updatedIds));

    const finalArray = uniqueUpdatedIds.map((id) => {
      let updatedActivityValues = apiRef.current.getRowWithUpdatedValues(id);
      return {
        activation: "HideOrShow",
        copySubmitQuota: updatedActivityValues.copySubmitQuota,
        stickToQuota: updatedActivityValues.stickToQuota,
        unblockFullOrder : updatedActivityValues.unblockFullOrder,
        modifyStickToQuota: updatedActivityValues.modifyStickToQuota,
        groupOrScenarioID: updatedActivityValues.groupOrScenarioID,
        groupOrScenarioType: viewBy,
        inactive: updatedActivityValues.inactive,
        scenarioCriticality: updatedActivityValues.scenarioCriticality,
      };
    });

    let obj = {
      countryID: selectedCountryID,
      viewBy: viewBy,
    };

    dispatch(ListUpdateGroupOrScenario(finalArray)).then(() => {
      setUpdatedIds([]);
      console.log(listUpdateGS);
      dispatch(GetGroupOrScenarioDetails(obj));
    });
  };

  const displayWarningAlert = (severityType) => {
    setAlert({
      alertSeverity: "warning",
      alertDisplay: true,
      alertMessage: `Please select the ${severityType}`,
    });

    setTimeout(() => {
      clearAlert();
    }, [3000]);
  };

  const clearAlert = () => {
    setAlert({
      alertSeverity: "",
      alertDisplay: false,
      alertMessage: ``,
    });
  };

  return (
    <CollapseSection title="Group / Scenario Activity">
      <Box mt={2}>
        <Grid
          container
          columns={12}
          justifyContent="space-between"
          alignItems="center"
          spacing={2}
          pb={1}
        >
          <Grid item xs={6} sm={3} md={3} lg={3}>
            <TextField
              variant="outlined"
              label="Country"
              select={countries.length > 0 ? true : false}
              value={countries.length > 0 ? selectedCountry.countryName : ""}
              onChange={handleCountryChange}
              fullWidth
              size="small"
            >
              {countries.length > 0
                ? countries.map((country, index) => {
                    return (
                      <MenuItem
                        key={country.countryID}
                        value={country.countryName}
                      >
                        {country.countryName}
                      </MenuItem>
                    );
                  })
                : null}
            </TextField>
          </Grid>

          <Grid item xs={6} sm={3} md={3} lg={3}>
            <TextField
              variant="outlined"
              label="View By"
              select={true}
              value={viewBy}
              onChange={(e) => setViewBy(e.target.value)}
              fullWidth
              size="small"
            >
              <MenuItem key={1} value={1}>
                {"Product Group"}
              </MenuItem>
              <MenuItem key={2} value={2}>
                {"Customer Group"}
              </MenuItem>
              <MenuItem key={3} value={3}>
                {"Scenario"}
              </MenuItem>
            </TextField>
          </Grid>

          <Grid item xs={6} sm={3} md={3} lg={3}>
            {getGroupScenarioData.length > 0 && (
              <TextField
                variant="outlined"
                label="Search"
                value={searchText}
                onChange={handleSearchText}
                fullWidth
                size="small"
              ></TextField>
            )}
          </Grid>

          <Grid item xs={12} sm={3} md={3} lg={3}>
            <Box justifyContent="center" display="flex">
              <Button variant="contained" onClick={handleDisplay} size="large">
                Display
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Box>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress />
      </Backdrop>
      <SharedComponent />
      {getGroupScenarioData && (
        <Box mt={2} sx={{ width: "100%" }}>
          <DataGrid
            disableColumnMenu
            style={{ maxHeight: "calc(100vh - 130px)" }}            
            sx={{
              "& .MuiDataGrid-columnHeaderTitle": {
                whiteSpace: "normal",
                lineHeight: "normal",
              },
              "& .MuiDataGrid-columnHeader": {
                position: "sticky",
              },
              "& .MuiDataGrid-columnHeaders": {
                maxHeight: "168px !important",
              },
              '& .MuiDataGrid-cell': {
                whiteSpace: 'normal !important',
                wordWrap: 'break-word !important',
              }
            }}
            apiRef={apiRef}
            rows={filterData || []}
            columns={visibleColumns}
            getRowId={(row) => row?.groupOrScenarioID}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 20,
                },
              },
            }}
            pageSizeOptions={[20, 50, 100]}
            disableRowSelectionOnClick
          />
        </Box>
      )}
      <Grid item xs={12} sm={12} md={12} lg={12} mt={2}>
        <Box justifyContent="right" display="flex">
          <Button variant="contained" size="large" onClick={handleSave}>
            Save
          </Button>
        </Box>
      </Grid>
      {alert.alertDisplay && (
        <Alert
          message={alert.alertMessage}
          variant="filled"
          severity={alert.alertSeverity}
        />
      )}
    </CollapseSection>
  );
}
